export const FETCH_CAR_DATA = 'CarDetail/FETCH_CAR_DATA';
export const FETCH_CAR_DATA_FAILURE = 'CarDetail/FETCH_CAR_DATA_FAILURE';
export const SEND_MESSAGE_REQUEST = 'CarDetail/SEND_MESSAGE_REQUEST';
export const RESET_ALL_CAR_DETAIL_OPTION = 'CarDetail/RESET_ALL_CAR_DETAIL_OPTION';